<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/companies')">Compañías</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Añadir Compañía</a>
  </div>
  <h1 class="ui header"><i class="icon building"></i><div class="content">Añadir Compañía</div></h1>
  <button class="ui basic button rightButton" v-on:click="goTo('/Companies')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="newCompany">
          <h4 class="ui dividing header">Información de la compañia</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="newCompanyData.active" />
          </div>
          <div class="field">
            <label>Nombre *</label>
            <input type="text" v-model="newCompanyData.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Imagen de la Compañía</label>
            <input type="file" accept="image/*" @change="onFilePicked">
          </div>
          <div class="field">
            <label>Descripción</label>
            <textarea rows="4" maxlength="200" v-model="newCompanyData.description"></textarea>
          </div>
          <div class="field">
            <label>External name *</label>
            <input type="text" v-model="newCompanyData.external_name" placeholder="External name" required>
          </div>
          <div class="field">
              <label>Tema del Admin</label>
              <sui-dropdown placeholder="Tema" search selection :options="adminThemeOptions" v-model="newCompanyData.admin_theme_id" required />
          </div>
          <button class="ui button" type="submit">Crear</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'addCompany',
  data() {
    return {
      newCompanyData: {
        name: null,
        description: null,
        image: null,
        external_name:null,
        admin_theme_id: null,
        active: 1,
      },
      adminThemeOptions: [],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    if(role === 'master' || role === 'admin'){
      this.getDataFilters()
    }else{
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    newCompany() {
      hapiickApi().post('/v2/companies/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        newCompanyData: this.newCompanyData
      })
      .then(request => this.companySaved(request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'No se han podido guardar los datos'
      }))
    },
    goTo(where) {
      this.$router.push(where)
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.newCompanyData.image = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    companySaved(req){
      if (req.data.status !== 'OK') {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'No se han podido guardar los datos'
        })
      }
      this.$swal({
        type: 'success',
        title: 'Los datos se han guardado correctamente',
        showConfirmButton: false,
        timer: 2500
      })
      this.newCompanyData.active = 1
      this.newCompanyData.name = null
      this.newCompanyData.description = null
      this.newCompanyData.image = null
      this.newCompanyData.external_name = null
      this.goTo('/companies')
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        AdminTheme: true
      })
      .then(request => {
        this.fillAdminThemeOptions(JSON.parse(JSON.stringify(request.data.data.adminTheme)))
      })
      .catch(() => console.log('error getting combo filters'))
    },
    fillAdminThemeOptions(adminTheme) {
      for (let i = 0; i < adminTheme.length; i++) {
        this.adminThemeOptions.push({
          text: adminTheme[i].AdminTheme.name,
          value: adminTheme[i].AdminTheme.id,
          id: adminTheme[i].AdminTheme.id
        })
      }
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Companies/addCompany.vue